import { AssetProps } from '@websrc/App/Components/Asset/Asset'

export const hasAsset = (asset: AssetProps | undefined) =>
  // The parser would otherwise not recognize that asset is defined in the second proposition
  // eslint-disable-next-line no-implicit-coercion
  !!asset && Boolean(asset.video ?? asset.thumbnail)
